import { PageType } from "shared/lib/page-type";

export const pathname = "/plus/archive";

export const page = {
  route(query: QueryParameters<{ nodeId?: string }>) {
    return { pathname, query: { ...query, pageType: PageType.Plus } };
  },
};
